import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';

@Injectable()
export class ApplicationErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

  handleError(errorResponse: HttpErrorResponse | any) {
    console.log('errorResponse :   ->', errorResponse);
    if (errorResponse instanceof HttpErrorResponse) {
        console.log(errorResponse);
        console.log('caiu aqui  --------');
    //   this.zone.run(() => {
    //     const errorDetails = createListErrors(errorResponse);
    //     this.genericModalService.exibirModal('Erro:', '', errorDetails);
    //   });
      super.handleError(errorResponse);
    }
  }
}
// function createListErrors(errorResponse: HttpErrorResponse) {
//   let errorDetails: any = {};
//   if (errorResponse.status !== 0) {
//     errorDetails = errorResponse.error
//       ? {
//           titulo: errorResponse.error.title,
//           status: errorResponse.error.status,
//           detalhes: errorResponse.error.detail,
//           timestamp: errorResponse.error.timestamp,
//           developer: errorResponse.error.developerMessage,
//           uuid: errorResponse.error.uuid
//         }
//       : {
//           titulo: 'Ocorreu um erro!'
//         };
//   } else {
//     errorDetails = {
//       titulo: 'Ocorreu um erro na comunicação com a API. Tente novamente mais tarde.',
//       status: '500'
//     };
//   }
//   return errorDetails;
// }
